import { create } from 'zustand'

export interface MatchInfo {
  section: string | null
  pageNumber: number | null
  snippet: string
  query: string
}

interface MatchCacheState {
  byChunkId: Record<string, MatchInfo>
  setMatch: (chunkId: string, info: MatchInfo) => void
  clearMatch: (chunkId: string) => void
}

export const useMatchCache = create<MatchCacheState>(set => ({
  byChunkId: {},
  setMatch: (chunkId, info) => set(s => ({ byChunkId: { ...s.byChunkId, [chunkId]: info } })),
  clearMatch: chunkId =>
    set(s => {
      const { [chunkId]: _, ...rest } = s.byChunkId
      return { byChunkId: rest }
    }),
}))
